window.addEventListener('DOMContentLoaded', setCustomizationPopupPadding);
window.addEventListener('scroll', setCustomizationPopupPadding);
window.addEventListener('resize', setCustomizationPopupPadding);

function setCustomizationPopupPadding() {
    var header = document.querySelector('store-header');
    var announcementBar = document.querySelector('announcement-bar');
    var popupContainers = document.querySelectorAll('.customization_popup_container');

    var headerHeight = 0;

    if (header) {
        if (header.classList.contains('is-out')) { // "is-out" means the extended header is hidden
            headerHeight = header.clientHeight;
        } else {
            headerHeight = header.clientHeight;
            if (document.documentElement.scrollTop < 20) {
                headerHeight += announcementBar.clientHeight
            }
        }
    }

    popupContainers.forEach(function(popupContainer) {
        if (popupContainer) {
            popupContainer.style.paddingTop = headerHeight + 'px';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    var popupTriggers = document.querySelectorAll('.customization_popup_trigger');
    var popups = document.querySelectorAll('.customization_popup');
    var popImg = document.getElementById('pop-img');
    var printButton = document.getElementById('print-btn');

    popupTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(event) {
            event.preventDefault();
            popups[0].classList.add('is-visible');
            var img = this.getAttribute('data-img');
            popImg.setAttribute('src', img);
            popImg.style.display = 'block';

            var file = this.getAttribute('data-file');
            printButton.setAttribute('href', file);
        });
    });

    popups.forEach(function(popup) {
        popup.addEventListener('click', function(event) {
            if (event.target.classList.contains('customization_popup_close') || event.target.classList.contains('customization_popup')) {
                event.preventDefault();
                this.classList.remove('is-visible');
                popImg.style.display = 'none';
                popImg.removeAttribute('src');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    var wxPopupTriggers = document.querySelectorAll('.wx_customization_popup_trigger');
    var wxPopups = document.querySelectorAll('.wx.customization_popup');

    wxPopupTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(event) {
            console.log('test');
            event.preventDefault();
            wxPopups[0].classList.add('is-visible');
        });
    });

    wxPopups.forEach(function(popup) {
        popup.addEventListener('click', function(event) {
            if (event.target.classList.contains('wx.customization_popup_close') || event.target.classList.contains('wx.customization_popup')) {
                event.preventDefault();
                this.classList.remove('is-visible');
            }
        });
    });

    document.addEventListener('keyup', function(event) {
        if (event.which == '27') {
            wxPopups.forEach(function(popup) {
                popup.classList.remove('is-visible');
            });
        }
    });
});